import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../client";

function tenantBrandingKey(slug) {
  return ["tenants", slug, "branding"];
}

async function fetchTenantBranding(slug) {
  // Public endpoint — no auth required; defined in TASK-02 / docs/05 §2
  const response = await apiClient.get(`/api/v1/companies/${slug}/public/`);
  return response.data;
}

/**
 * TanStack Query hook for a tenant's public branding data (name, logo, primary color).
 * Only fetches when slug is truthy.
 */
function useTenantBranding(slug, options = {}) {
  return useQuery({
    queryKey: tenantBrandingKey(slug),
    queryFn: () => fetchTenantBranding(slug),
    enabled: Boolean(slug),
    staleTime: 10 * 60 * 1000, // 10 min — branding changes very rarely
    ...options,
  });
}

export { useTenantBranding, tenantBrandingKey };
